import React from 'react'
import { useSelector } from "react-redux"

import FavoriteCard from '../components/FavoriteCard'

function Favorites() {
    const favorites = useSelector((state) => state.favoriteReducer.favorites)
    // console.log('favorites' ,favorites);

    return(
        <div className="container mt-3">
            <h1 style={{color:"#1d2b5e"}}>My Favorite Pokemons</h1>
            <div className="card-deck mr-3">
                {favorites.map((pokemon, i) => {
                    return (
                        <FavoriteCard 
                            pokemon = {pokemon} 
                            key= {i} />
                        )
                    })}
            </div>
        </div>
    )
}

export default Favorites